export const Auth = {
  initial: () => initial(),
  from: (isLoggedIn, token, user) => from(isLoggedIn, token, user),
};

const initial = () => ({ isLoggedIn: false, token: null, user: null });

const from = (isLoggedIn, token, user) => ({
  isLoggedIn,
  token,
  user,
});
